// extracted by mini-css-extract-plugin
export var drawer = "users-speakers-module--drawer--8e992";
export var drawerClose = "users-speakers-module--drawer-close--467e1";
export var show = "users-speakers-module--show--f05d6";
export var userCard = "users-speakers-module--user-card--34acf";
export var userName = "users-speakers-module--user-name--025d4";
export var userTitle = "users-speakers-module--user-title--c978f";